<script setup lang="ts">
/**
 * NuovaVersioneBanner — avviso in basso: c'è una versione nuova del portale. Il ricaricamento lo sceglie l'utente
 * (non si ricarica mai da soli: si perderebbe ciò che è in corso di scrittura). Vedi `useNuovaVersione`.
 */
import { useI18n } from 'vue-i18n'
import Button from 'primevue/button'
import { useNuovaVersione } from '@/composables/useNuovaVersione'

const { t } = useI18n()
const { disponibile, rimanda, ricarica } = useNuovaVersione()
</script>

<template>
  <Transition name="nuova-versione">
    <div
      v-if="disponibile"
      class="nuova-versione"
      role="status"
      aria-live="polite"
      data-sezione="nuova-versione"
    >
      <i
        class="pi pi-sync nuova-versione-icona"
        aria-hidden="true"
      />
      <div class="nuova-versione-testo">
        <strong>{{ t('common.nuovaVersione.titolo', 'È disponibile una nuova versione') }}</strong>
        <span>{{ t('common.nuovaVersione.testo', 'Ricarica quando hai finito: ciò che non hai salvato andrebbe perso.') }}</span>
      </div>
      <Button
        :label="t('common.nuovaVersione.piuTardi', 'Più tardi')"
        text
        size="small"
        @click="rimanda"
      />
      <Button
        :label="t('common.nuovaVersione.ricarica', 'Ricarica ora')"
        icon="pi pi-refresh"
        size="small"
        @click="ricarica"
      />
    </div>
  </Transition>
</template>

<style scoped>
.nuova-versione {
  position: fixed;
  left: 50%;
  bottom: 1.25rem;
  z-index: 1100;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: max-content;
  max-width: calc(100vw - 2rem);
  padding: 0.75rem 1rem;
  border: 1px solid var(--p-content-border-color);
  border-left: 4px solid var(--p-primary-color);
  border-radius: var(--p-content-border-radius);
  background: var(--p-content-background);
  color: var(--p-text-color);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);
  transform: translateX(-50%);
}
.nuova-versione-icona {
  font-size: 1.25rem;
  color: var(--p-primary-color);
}
.nuova-versione-testo {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
}
.nuova-versione-testo span {
  font-size: 0.875rem;
  color: var(--p-text-muted-color);
}
@media (max-width: 640px) {
  .nuova-versione {
    flex-wrap: wrap;
  }
  .nuova-versione-testo {
    flex-basis: calc(100% - 3rem);
  }
}
.nuova-versione-enter-active,
.nuova-versione-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.nuova-versione-enter-from,
.nuova-versione-leave-to {
  opacity: 0;
  transform: translate(-50%, 0.75rem);
}
@media (prefers-reduced-motion: reduce) {
  .nuova-versione-enter-active,
  .nuova-versione-leave-active {
    transition: none;
  }
}
</style>
